/* eslint-disable no-unused-vars */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// eslint-disable-next-line import/no-unresolved
import bwipjs from 'bwip-js';

function LaneLabels(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  // Get the query string (e.g., "?param=value&foo=bar")
  const queryString = window.location.search;

  // Parse it using URLSearchParams
  const params = new URLSearchParams(queryString);

  // Get specific parameter
  const lns = params.get('lanes');

  // Split the parameter into an array
  const lanes = lns.split(',');

  const generateDataMatrix = (text) => {
    try {
      // Use bwip-js to generate the barcode
      const canvas = document.createElement('canvas');
      bwipjs.toCanvas(canvas, {
        bcid: 'datamatrix', // Barcode type
        text: `:${text}`, // Content of the barcode
        scale: 10, // Scale factor for better resolution
        includetext: false, // Exclude text below the barcode
        backgroundcolor: 'ffffff', // White background
      });
      return canvas.toDataURL(); // Convert canvas to Base64 image
    } catch (err) {
      return null;
    }
  };

  return (
    <div>
      {lanes.map((lane) => (
        <div className="page" key={`_${lane}`}>
          <div className="barcode">
            <img src={generateDataMatrix(lane)} alt={`Barcode for ${lane}`} />
          </div>
          <div
            style={{
              fontSize: '300px',
              textAlign: 'center',
            }}
          >
            {lane.toUpperCase()}
          </div>
        </div>
      ))}

      <style>
        {`
          @page {
            size: letter;
            margin: 0mm;
            padding: 0mm;
          }
          
          body {
            margin: 0mm;
          }

          .barcode {
            margin-left: 40px;
            margin-top: 1.5in;
          }
  
          .page {
            display: flex;
            flex-direction: column;
            align-items: center;
            page-break-after: always;
          }
        `}
      </style>
    </div>
  );
}

LaneLabels.defaultProps = {
  t: (x) => (x),
};

LaneLabels.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(LaneLabels));
